import axios from 'axios';
export default {
  index({
    preUrl,
    url = null,
    parentName = null,
    parentId = null,
    modelName,
    params,
    pagination = false,
  }) {
    let _url = '';
    if (url) _url = `/${url}`;
    else {
      if (preUrl) {
        _url += `${preUrl}`;
      }
      if (parentName) {
        _url += `/${parentName}/${parentId}`;
      }
      if (modelName) {
        _url += `/${modelName}`;
      }
    }
    return new Promise((resolve) => {
      axios
        .get(_url, {
          params: {
            ...params
          },
        })
        .then((res) => {
          if (pagination) {
            resolve(res.data);
          } else {
            resolve(res.data.data);
          }
        })
        .catch(err => {
          alert(err);
        });
    });
  },
  async update({modelName, modelId, payload}) {
    try {
      await axios.patch(`/${modelName}/${modelId}`, payload);
    } catch(error) {
      if (
        error &&
        error.response &&
        error.response.data.message == "data update fail."
      ) {
        alert("更新失敗");
      } else {
        alert("更新失敗");
      }
    }
  },
  show({ url = null, modelName = null, modelId = null, params, cancelTokenSource = null, }) {
    let _url = '';
    if (url) {
      _url = `/${url}`;
    } else {
      _url = `/${modelName}/${modelId}`;
    }
    return new Promise((resolve) => {
      axios
        .get(_url, {
          params: {
            ...axios.defaults.params,
            ...params,
          },
          cancelToken: cancelTokenSource ? cancelTokenSource.token : null,
        })
        .then((res) => {
          if (res.data.data) resolve(res.data.data);
          else if (res.data) resolve(res.data);
          else resolve(res);
        })
        .catch((err) => {
          if (axios.isCancel(err)) console.log('Request canceled', err.message);
          else this.errorAction(err);
        });
    });
  },
  create({
    url = null,
    parentName = null,
    parentId = null,
    modelName = null,
    data,
  }) {
    let _url = '';
    if (url) {
      _url = `/${url}`;
    } else {
      if (parentName) {
        _url = `/${parentName}/${parentId}/${modelName}`;
      } else {
        _url = `/${modelName}`;
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .post(_url, data)
        .then((res) => {
          resolve(res.data.data ? res.data.data : res.data);
        })
        .catch((err) => {
          console.log(err);
          reject(err.response.data.message);
        });
    });
  },
  delete({ url = null, modelName, modelId, params }) {
    let _url = '';
    if (url) {
      _url = `/${url}`;
    } else if (modelName && modelId) {
      _url = `/${modelName}/${modelId}`;
    } else {
      return Promise.reject(new Error('url or modelName and modelId is required'));
    }
    return new Promise((resolve, reject) => {
      axios
        .delete(_url, {
          params,
        })
        .then((res) => {
          resolve(res.data.data);
        })
        .catch((err) => {
          reject(err?.response?.data?.message || err?.message || err);
        });
    });
  },
};
